export default __webpack_public_path__ + "static/media/Pending_Icon.f3f3c3be.svg";